import { type CombinedError, useQuery } from "urql"

import { FULL_LIST_LIMIT } from "@/constants/common"
import type { Instruction, Maybe, Query } from "@/graphql/codegen/graphql"
import { InstructionsListSuggestionDocument } from "@/graphql/codegen/graphql"

interface UseInstructionsSuggestionListReturn {
  instructions: Maybe<Instruction>[]
  fetching: boolean
  error?: CombinedError
}

const useInstructionsSuggestionList = ({
  query,
  isActive = true,
}: {
  query: string
  isActive?: boolean
}): UseInstructionsSuggestionListReturn => {
  const [{ data, error, fetching }] = useQuery<Pick<Query, "instruction">>({
    query: InstructionsListSuggestionDocument,
    variables: {
      input: {
        filter: {
          query,
          isActive,
        },
        offset: 0,
        limit: FULL_LIST_LIMIT,
      },
    },
    pause: query.length < 2, // Conditionally pause the query
  })
  const instructions =
    data?.instruction?.list?.__typename === "InstructionListSuccess" ? data?.instruction.list.instructions : []
  return {
    instructions,
    error,
    fetching,
  }
}

export default useInstructionsSuggestionList
